import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import { TableData } from './table-data.interface';
import * as _ from 'underscore';

@Component({
	selector: 'app-table-progressbar',
	templateUrl: './table-progressbar.component.html',
	styleUrls: ['./table-progressbar.component.css']
})
export class TableProgressbar extends BaseWidgetComponent implements OnInit {
	@Input() sectionclass: string;

	public tableData: any;
	public pageId: any;

	constructor(protected analyticsService: AnalyticsService) {
		super(analyticsService);
	}

	ngOnInit(): void {
		super.ngOnInit();
	}

	requestData(): void {
		this.pageId = 1;
		this.showLoad = true;
		this.hasData = false;
		this.tableData = [];
		this.analyticsService.processWidgetRequest(this.key, this.columns).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success && response.data.length > 0) {
				this.hasData = true;
				this.processResponseData(response.data);
			} else {
				this.hasData = false;
			}
		});
	}
	processResponseData(response: any): void {
		this.tableData = this.mapPlatformResponseToInterface(response);
		this.tableData = _.sortBy(
			_.sortBy(this.tableData, (item: any) => {
				return item.name;
			}).reverse(),
			(item: any) => {
				return Number(item.impressions);
			}
		).reverse();
	}

	mapPlatformResponseToInterface(responseArray: any[]): TableData[] {
		const tableData: TableData[] = [];
		for (const res of responseArray) {
			const item: TableData = {} as TableData;
			item.name = !UtilityService.isUndefinedOrNull(res.name) ? res.name : '';
			item.impressions = !UtilityService.isUndefinedOrNull(res.impressions) ? parseInt(res.impressions, 10) : 0;
			item.value25 = !UtilityService.isUndefinedOrNull(res['25_percent']) ? parseInt(res['25_percent'], 10) : 0;
			item.value50 = !UtilityService.isUndefinedOrNull(res['50_percent']) ? parseInt(res['50_percent'], 10) : 0;
			item.value75 = !UtilityService.isUndefinedOrNull(res['75_percent']) ? parseInt(res['75_percent'], 10) : 0;
			item.value100 = !UtilityService.isUndefinedOrNull(res['100_percent']) ? parseInt(res['100_percent'], 10) : 0;
			item.percent25 = this.getMaxPercent(res['25_rate']);
			item.percent50 = this.getMaxPercent(res['50_rate']);
			item.percent75 = this.getMaxPercent(res['75_rate']);
			item.percent100 = this.getMaxPercent(res['100_rate']);
			tableData.push(item);
		}
		return tableData;
	}

	getMaxPercent(value: string): string | number {
		if (!UtilityService.isUndefinedOrNull(value)) {
			return parseFloat(value) >= 100 ? '100' : parseFloat(value).toFixed(2);
		}
		return 0;
	}
}
